import React from 'react';
import { Row, Col, Card, Statistic, Typography, Spin } from 'antd';
import {
  AppstoreOutlined,
  FileTextOutlined,
  ExclamationCircleOutlined,
  BookOutlined
} from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../api/dashboard';

const { Title } = Typography;

const Dashboard: React.FC = () => {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: dashboardApi.getStats
  });

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <Title level={2}>Dashboard</Title>

      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Tổng số Apps"
              value={stats?.total_apps || 0}
              prefix={<AppstoreOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Tổng số Versions"
              value={stats?.total_versions || 0}
              prefix={<FileTextOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Force Updates"
              value={stats?.total_force_updates || 0}
              prefix={<ExclamationCircleOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Minimum Versions"
              value={stats?.total_minimum_versions || 0}
              prefix={<BookOutlined />}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title="Hoạt động gần đây" bordered={false}>
            <p>Chưa có hoạt động nào</p>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Thống kê hệ thống" bordered={false}>
            <p>Thông tin thống kê sẽ hiển thị ở đây</p>
          </Card>
        </Col>
      </Row>

    </div>
  );
};

export default Dashboard;
